import React, { useEffect, useState } from "react";

const Radio = ({ Title, data, onChange, userQuery, setUserQuery }) => {
  const [active, setActive] = useState("");
  useEffect(() => {
    if (Title === "Occupancy *") {
      setActive(  userQuery.occupancy_status != "" ? userQuery.occupancy_status : "");
    }
    if (Title === "Loan Purpose") {
      setActive(userQuery.Loan_purpose != "" ? userQuery.Loan_purpose : "");
    }
    if (Title === "Mortgage Type") {
      setActive(userQuery.Mortgage_Type != "" ? userQuery.Mortgage_Type : "");
    }
    if (Title === "Bankruptcy type") {
      setActive(userQuery.bankruptcy_type != "" ? userQuery.bankruptcy_type : "");
    }
    console.log("Title:", Title);
  }, []);

  const handleRadioClick = (value) => {
    console.log("value:", value, Title);
    if (Title === "Occupancy *") {
      if (value === "Primary Residence") {
        setUserQuery({ ...userQuery, occupancy_status: "Primary Residence" });
      } else if (value === "Second Home") {
        setUserQuery({ ...userQuery, occupancy_status: "Second Home" });
      } else if (value === "Investment Property") {
        setUserQuery({ ...userQuery, occupancy_status: "Investment Property" });
      }
    }

    if (Title === "Loan Purpose") {
      if (value === "Purchase") {
        setUserQuery({ ...userQuery, Loan_purpose: "Purchase" });
      } else if (value === "No Cash-Out Refi") {
        setUserQuery({ ...userQuery, Loan_purpose: "No Cash-Out Refi" });
      } else if (value === "Cash-Out Refi") {
        setUserQuery({ ...userQuery, Loan_purpose: "Cash-Out Refi" });
      }
    }

    if (Title === "Mortgage Type") {
      if (value === "NON-QM") {
        setUserQuery({ ...userQuery, Mortgage_Type: "NON-QM" });
      } else if (value === "QM") {
        setUserQuery({ ...userQuery, Mortgage_Type: "QM" });
      } else if (value === "Jumbo") {
        setUserQuery({ ...userQuery, Mortgage_Type: "Jumbo" });
      }
    }
    if (Title === "Bankruptcy type") {
      if (value === "None") {
        setUserQuery({ ...userQuery, bankruptcy_type: "None"});
      } else if (value === "Chapter 7") {
        setUserQuery({ ...userQuery, bankruptcy_type: "Chapter 7"});
      } else if (value === "Chapter 11") {
        setUserQuery({ ...userQuery, bankruptcy_type: "Chapter 11"});
      } else if (value === "Chapter 12") {
        setUserQuery({ ...userQuery, bankruptcy_type: "Chapter 12"});
      } else if (value === "Chapter 13") {
        setUserQuery({ ...userQuery, bankruptcy_type: "Chapter 13"});
      }
    }
    setActive(value);
    onChange(value)
    console.log("value", value, active);
  };

  return (
    // This is the component for Radio buttons used in the project

    <div className="flex w-full mt-4 rounded-lg max-[600px]:flex-col ">
      <div className="flex max-[600px]:rounded-lg   w-1/5 max-[600px]:mt-5  bg-[#E1EFFE] max-[600px]:w-full rounded-l-lg border border-[#86B8EE] ">
        <label className="pl-5 p-2 font-medium">{Title}</label>
      </div>
      <div className="flex w-4/5 max-[600px]:rounded-lg max-[600px]:flex-col max-[600px]:p-2 max-[600px]:w-full max-[600px]:items-start justify-between items-center px-4 border border-[#E0E0E0] rounded-r-lg ">
        {data.map((item, index) => {
          // console.log("item", item, item.value, index);
          return (
            <div
              onClick={(e) => {
                handleRadioClick(item.value);
                onChange(item.value);
              }} // Handle label click
              className="flex items-center me-4  xl:w-1/3 "
              key={index}
            >
              <input
                type="radio"
                value={item.value}
                onChange={(e) => onChange(e.target.value)}
                checked={active === item.value} // Check if the input is active
                className={`appearance-none w-4 h-4 bg-white  rounded-full  cursor-pointer ${
                  active === item.value
                    ? "border-2 border-[#ff6839]  ring-2 ring-[#ff6839]"
                    : "border border-black"
                }`}
              />
              <label className="ms-2 cursor-pointer  text-black">
                {item.label}
              </label>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Radio;
